<div id="admin-menu">
    <div id="admin-menu-header">
        <span *ngIf="action !== 'View'">{{ action }} </span>

        <span>Client Information</span>
        <span *ngIf="action !== 'Add'"> &mdash; {{ clientModel.clientDetails.shortName }}</span>
        <span (click)="closeForm()" class="closeButton">
            <i class="fas fa-times"></i>
        </span>
    </div>
    <br />

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-tab-group
            #upsertTabBar
            (selectedTabChange)="tabChangeHandler($event)"
            [animationDuration]="'1000'"
        >
            <!-- (Group) Client Details -->
            <mat-tab [label]="'Company Info'">
                <client-edit-details
                    [form]="form"
                    [action]="action"
                    [clientModel]="clientModel"
                    (formGroupEvent)="buildDetailsGroup($event)"
                >
                </client-edit-details>
            </mat-tab>

            <!-- (Group) Contacts -->
            <mat-tab class="mat-tab" [label]="'Contacts'">
                <client-edit-contacts
                    [form]="form"
                    [action]="action"
                    [clientInfoSources]="clientInfoSources"
                    (formGroupEvent)="buildContactsGroup($event)"
                >
                </client-edit-contacts>
            </mat-tab>

            <!-- (Group) Identities -->
            <mat-tab [label]="'Identities'">
                <client-edit-identities
                    [form]="form"
                    [action]="action"
                    [clientInfoSources]="clientInfoSources"
                    [clientKey]="clientKey"
                    (formGroupEvent)="buildIdentifiersGroup($event)"
                >
                </client-edit-identities>
            </mat-tab>

            <!-- (Group) Integrations -->
            <mat-tab [label]="'Integrations'">
                <client-edit-integrations
                    [form]="form"
                    [action]="action"
                    [clientModel]="clientModel"
                    [isNVLite]="isNVLite"
                    [clientInfoSources]="clientInfoSources"
                    (formGroupEvent)="buildIntegrationsGroup($event)"
                >
                </client-edit-integrations>
            </mat-tab>
        </mat-tab-group>

        <!-- Tab Buttons -->
        <div width="150px" class="tabArea">
            <ng-container>
                <button mat-raised-button (click)="closeForm()" type="button" outlined>
                    Cancel
                </button>
            </ng-container>
            <ng-container *ngIf="action !== 'View'">
                &nbsp;&nbsp;
                <button mat-raised-button primary [disabled]="isSaveDisabled()">Save</button>
            </ng-container>
            <ng-container *ngIf="action === 'View'">
                &nbsp;&nbsp;
                <button mat-raised-button type="button" outlined (click)="action = 'Edit'">
                    Edit
                </button>
            </ng-container>
        </div>
    </form>
</div>
